import { notifyWarning } from '@/libs/notify'
import { isMicDenied } from '@/libs/audioDevices'
import { ROUTE_SETTINGS } from '@/router/constants'

export const MIC_MISSING = 'Microfone não encontrado. Conecte o headset ou selecione outro microfone.'
export const MIC_DENIED = 'Acesso ao microfone bloqueado. Permita nas configurações do site e tente novamente.'

export default () => {
  if (isMicDenied()) return notifyWarning(MIC_DENIED)

  notifyWarning(MIC_MISSING, {
    actions: [{
      label: 'Configurar',
      flat: true,
      noCaps: true,
      handler: () => document.router.push({ name: ROUTE_SETTINGS }).catch(() => {})
    }]
  })
}
